//
// Sitewide JavaScript code, admin-site
//

$(document).ready(function() {
    // init the selects as Select2
    initSelects();

    // if an ACTIVE_NAV global is defined, find that item in the nav menu and tag is as .active so it gets alternate coloring
    if (typeof ACTIVE_NAV !== 'undefined') {
        $('a[data-active="'+ACTIVE_NAV+'"]').addClass('active-nav');
    }
});


function initSelects() {
    // Every form with a <select>, transform this to a Select2
    $('select').each(function() {
        var select = $(this);
        var placeholder = select.attr('placeholder'); // optionally include a placeholder attribute
        var clear = select.attr('allowclear');        // optionally include clear=true to allow the clear button
        var search = select.attr('allowsearch');      // optionally allow search within the select2
        select.select2({
            placeholder: placeholder,
            minimumResultsForSearch: search ? 0 : Infinity,
            allowClear: clear
        });
    });
}